import React, { useEffect, useState } from "react";
import Loader from "./Loader";
import { TailSpin } from "react-loader-spinner";
import UserList from "./UserList";
import Pagination from "./Pagination";
import NavBar from "./Navbar";
import TopNavBar from "./TopNavbar";
import Search from "./Search";
import {
  fetchUsers,
  fetchArchivedUsers,
  fetchUserCount,
  fetchArchivedUserCount,
} from "../services/UserService";
import "../styles/AdminPanel.css";
import axios from "axios";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import addEmployeeIcon from "../images/addEmployeeIcon.svg";
import { useAuth } from "../auth/auth";
import {
  deniedActionClass,
  usePermissionGuard,
} from "../hooks/usePermissionGuard";
import { PERMISSIONS } from "../utils/rbac";
const apiUrl = process.env.REACT_APP_API_URL;

function AdminPanel() {
  const navigate = useNavigate();
  const { guardAction, PermissionDialog, isAllowed } = usePermissionGuard();
  const canAddEmployee = isAllowed(PERMISSIONS.CREATE_EMPLOYEE);
  const [users, setUsers] = useState([]);
  // const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(15);
  const [searchResult, setSearchResult] = useState([]);
  const [showAllUsers, setShowAllUsers] = useState(true); // Track whether to show all users or search result
  const [isLoading, setIsLoading] = useState(true);
  const [loading, setLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const pageParam = parseInt(searchParams.get("page")) || 1;
  const [currentPage, setCurrentPage] = useState(pageParam);
  const [isArchivedView, setIsArchivedView] = useState(false);

  useAuth();

  const handleBlockUser = async (email) => {
    try {
      await axios.post("http://localhost:5000/block", { email });
      const updatedUsers = users.map((user) => {
        if (user.email === email) {
          // Toggle the 'blocked' status
          user.blocked = !user.blocked;
        }
        return user;
      });
      setUsers(updatedUsers);
    } catch (error) {
      //console.error("Failed to block/unblock user:", error);
    }
  };

  const handleDeleteUser = async (email) => {
    const confirmed = true;
    // const confirmed = window.confirm(
    //   `Are you sure you want to delete the user ${email}?`
    // );
    if (confirmed) {
      try {
        const employeeId = email;
        const resp = await axios.delete(`${apiUrl}/users/${employeeId}`);
        const message = resp?.data?.message || "Employee deleted successfully";
        alert(message);
        const updatedUsers = users.filter((user) => user.id !== employeeId);
        setUsers(updatedUsers);
        window.location.reload();
      } catch (error) {
        const status = error?.response?.status;
        const message =
          error?.response?.data?.message ||
          (status === 409
            ? "Employee has related data. Cannot delete."
            : "Failed to delete employee");
        alert(message);
      }
    }
  };

  const handleSearch = (searchResultUser) => {
    if (users.length === 0) {
      setSearchResult([]); // Ensure search does not show results if no users exist
    } else {
      setSearchResult(searchResultUser);
      setShowAllUsers(false);
    }
  };

  const handleShowAllUsers = () => {
    setShowAllUsers(true); // Set to true to display all users
    setSearchResult([]);
    //window.location.href = "/admin";//no need as useEffect re rendring page
  };

  const [count, setCount] = useState(0);

  useEffect(() => {
    async function fetchData() {
      try {
        const userCount = isArchivedView
          ? await fetchArchivedUserCount()
          : await fetchUserCount();
        setCount(userCount);
      } catch (error) {}
    }
    fetchData();
  }, [isArchivedView]);

  useEffect(() => {
    async function fetchData() {
      setLoading(true);

      try {
        if (searchResult.length > 0) {
          setUsers(searchResult); // Display search result if available
        } else {
          const response = isArchivedView
            ? await fetchArchivedUsers(currentPage, pageSize)
            : await fetchUsers(currentPage, pageSize);
          const collectedUsers = response.map((element) => element);

          setUsers(collectedUsers); // Display list of users
        }
      } catch (error) {
        //console.error("Failed to fetch user data:", error);
      } finally {
        setLoading(false);
        setIsLoading(false);
      }
    }
    fetchData();
  }, [currentPage, pageSize, searchResult, showAllUsers, isArchivedView]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    setSearchParams({ page });
  };

  const handleToggleView = (archived) => {
    setIsArchivedView(archived);
    setCurrentPage(1);
    setSearchResult([]);
    setShowAllUsers(true);
    setSearchParams({ page: 1 });
  };

  const handleArchiveUser = async (id) => {
    const confirmed = true;
    if (!confirmed) return;
    try {
      await axios.post(`${apiUrl}/archiveEmployee`, {
        employeeId: id,
        type: "archive",
      });
      window.location.reload();
    } catch (error) {}
  };

  const handleUnarchiveUser = async (id) => {
    const confirmed = true;
    if (!confirmed) return;
    try {
      await axios.post(`${apiUrl}/archiveEmployee`, {
        employeeId: id,
        type: "unarchive",
      });
      window.location.reload();
    } catch (error) {}
  };

  return (
    <div className="admin-panel-parent-container">
      <PermissionDialog />
      <NavBar />
      <TopNavBar />
      <div className="admin-card admin-panel">
        <div className="admin-card-body">
          <div className="admin-header">
            <div
              className="left-section"
              style={{ display: "flex", gap: "50px", alignItems: "center" }}
            >
              <h1 className="admin-header-title">
                <span className="admin-card-title-span">Manage Employee</span>
              </h1>
              <div>
                <button
                  style={{
                    marginRight: "8px",
                    padding: "4px 10px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: !isArchivedView ? "#2E8056" : "#E0E0E0",
                    color: !isArchivedView ? "#fff" : "#333",
                    fontWeight: 500,
                  }}
                  onClick={() => handleToggleView(false)}
                >
                  Active
                </button>
                <button
                  style={{
                    padding: "4px 10px",
                    marginRight: "8px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor: isArchivedView ? "#2E8056" : "#E0E0E0",
                    color: isArchivedView ? "#fff" : "#333",
                    fontWeight: 500,
                  }}
                  onClick={() => handleToggleView(true)}
                >
                  Archived
                </button>
                {/* <button
                  style={{
                    padding: "4px 10px",
                    marginRight: "8px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor:
                      selectedYear === 2025 ? "#2E8056" : "#E0E0E0",
                    color: selectedYear === 2025 ? "#fff" : "#333",
                    fontWeight: 500,
                  }}
                  onClick={() => handleYearChange(2025)}
                >
                  2025
                </button>
                <button
                  style={{
                    padding: "4px 10px",
                    borderRadius: "8px",
                    border: "none",
                    cursor: "pointer",
                    backgroundColor:
                      selectedYear === 2026 ? "#2E8056" : "#E0E0E0",
                    color: selectedYear === 2026 ? "#fff" : "#333",
                    fontWeight: 500,
                  }}
                  onClick={() => handleYearChange(2026)}
                >
                  2026
                </button> */}
              </div>
            </div>
            <div className="right-section">
              <Search
                onSearch={handleSearch}
                onClear={handleShowAllUsers}
                searchPath={isArchivedView ? "/searchArchived" : "/search"}
              />
              <Link
                to="/addEmployee"
                className={`add-user-link small-screen-link ${deniedActionClass(canAddEmployee)}`}
                onClick={(e) => {
                  e.preventDefault();
                  guardAction(PERMISSIONS.CREATE_EMPLOYEE, "add employee", () => {
                    navigate("/addEmployee");
                  });
                }}
              >
                <div className="add-user-container">
                  <img
                    src={addEmployeeIcon}
                    alt="Manage employee Icon"
                    className="addEmployeeIcon"
                  />
                  <span className="add-employee-text"> Add Employee</span>
                </div>
              </Link>
            </div>
          </div>
          {/* {loading && <Loader />} */}
          {loading && (
            <div className="spinner-container">
              <TailSpin
                type="TailSpin"
                color="rgb(155, 236, 34)"
                height={70}
                width={70}
                timeout={5000}
              />
            </div>
          )}
          <UserList
            users={users}
            onBlockUser={handleBlockUser}
            onDeleteUser={handleDeleteUser}
            currentPage={currentPage}
            pageSize={pageSize}
            showYtdColumn={false}
            isArchivedList={isArchivedView}
            onArchiveUser={handleArchiveUser}
            onUnarchiveUser={handleUnarchiveUser}
          />
          {searchResult.length === 0 ? (
            <Pagination
              currentPage={currentPage}
              pageSize={pageSize}
              totalUsers={count}
              onPageChange={handlePageChange}
            />
          ) : searchResult.length >= 15 ? (
            <Pagination
              currentPage={currentPage}
              pageSize={pageSize}
              totalUsers={count}
              onPageChange={handlePageChange}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default AdminPanel;

//notification nai aani chaiye,socket msg nai aane
